import axios from 'axios';

function apiBase(): string {
  return String(import.meta.env.VITE_APP_API_URL ?? '').replace(/\/$/, '');
}

export type DoorSettingsResponse = {
  missingTrimThreshold: number | null;
  trimColorsCacheTtlSeconds: number | null;
};

export async function getDoorSettings(accountId: string) {
  const { data } = await axios.get<DoorSettingsResponse>(`${apiBase()}/settings`, {
    params: { accountId },
  });
  return data;
}

export async function patchDoorSettings(
  accountId: string,
  patch: { missingTrimThreshold?: number | null; trimColorsCacheTtlSeconds?: number | null },
) {
  const { data } = await axios.patch<DoorSettingsResponse>(`${apiBase()}/settings`, {
    accountId,
    ...patch,
  });
  return data;
}
